import price from '@/api/product/price'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  locations: [],
  category_id: [],
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_CATEGORY(state, data) {
    state.categories = data
  },
  SET_LOCATION(state, data) {
    state.locations = data
  },
  SET_CATEGORIES(state, data) {
    console.log(data);
    state.category_id = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        category_id: context.state.category_id,
        search: context.state.search
      },
      attrubutes
    )
    return price.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return price.store(data)
  },
  update(context, data) {
    return price.update(data)
  },
  getBranch(context) {
    return price.branch()
  },
  getCategory(context) {
    return price.category()
  },
  fetchCurrentList(context) {
    return price.get({ params: { perPage: -1 } });
  }
}